export default {
  title: 'Excepciones de horario',
  fields: {
    status: {
      label: 'Estado',
    },
    date: {
      label: 'Fecha',
    },
    description: {
      label: 'Motivo',
    },
    recurring: {
      label: 'Recurrencia anual',
    },
    created: {
      label: 'Creado',
      creator: 'por {{name}}',
    },
    updated: {
      label: 'Actualizado',
    },
  },
  status: {
    closed: 'Cerrado',
    open: 'Abierto',
    paused: 'En pausa',
  },
  date: {
    all_day: 'Todo el día',
    paused_until_rest_of_day: 'En pausa hasta el final del día',
  },
  buttons: {
    pause_availability: '+ Pausar disponibilidad',
    close_availability: '+ Cerrar disponibilidad',
    amend_availability: '+ Modificar disponibilidad',
    sync_from_online_shop: 'Sincronizar desde la tienda online',
    close: 'Cerrar',
    delete: 'Eliminar',
  },
  projects: {
    online_shop: 'Tienda online',
    reservations: 'Reservas',
    storefront: 'Escaparate',
  },
  error_messages: {
    delete_failed: 'Error al eliminar. Por favor, inténtalo de nuevo.',
  },
  toasts: {
    sync_success: 'Sincronizado correctamente',
    sync_error:
      'Error al sincronizar las excepciones de horario desde la tienda online. Por favor, inténtalo de nuevo.',
  },
};
